export enum QueryOperator {
  EQUAL = ':',
  NOT_EQUAL = '!',
  LIKE = '~',
  GREATER_THAN = '>',
  LOWER_THAN = '<',
}
